<template>
    <div>
        <p class="mb-3 text-center">
            <slot name="labelText">{{ translate('Credits') }}:</slot>
            <br />
            <strong class="font-size-125">{{ selectedConversionMinutesReadable }}</strong>
        </p>
        <div class="px-5 pb-4">
            <VueSlider
                v-model="selectedConversionMinutes"
                :adsorb="true"
                :marks="getMark"
                tooltip="none"
                :clickable="true"
                :drag-on-click="true"
                :disabled="disabled"
                :data="Object.keys(selectableConversionMinutes)"
                :process="getProcess"
                :duration="0"
            ></VueSlider>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    name: 'SelectConversionMinutesSlider',
    components: { VueSlider },
    mixins: [TransFilter],
    props: {
        selectableConversionMinutes: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '500',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectedConversionMinutesReadable() {
            return this.selectableConversionMinutes[this.selectedConversionMinutes];
        },
    },
    watch: {
        selectedConversionMinutes(minutes, oldMinutes) {
            if (minutes === oldMinutes) {
                // no need to emit event if the value didn't change
                return;
            }

            this.$emit('input', minutes);
        },
    },
    methods: {
        getProcess(dotsPos) {
            return [[0, dotsPos[0], { backgroundColor: '#4285f4' }]];
        },
        getMark(value) {
            if (!this.selectableConversionMinutes[value]) {
                return {
                    label: '',
                };
            }

            // we can't display all possible values on the slider checkmarks,
            // but we still want to mark the position of all possible values
            // => skip some values by setting an empty string as label so the slider looks something like this:
            //
            // <=====#=====#=====#=====#=====#=====#=====#=====#=====>
            // 500             10.000           200.000          1.000.000
            const noLabelForMark = ['1000', '5000', '50000', '100000', '300000', '500000'];

            if (noLabelForMark.includes(value)) {
                return {
                    label: '',
                };
            }

            return {
                label: this.selectableConversionMinutes[value],
            };
        },
    },
    data() {
        return {
            selectedConversionMinutes: this.value,
        };
    },
};
</script>
